import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { CancelApplicationModule } from '@features/cancel-application/cancel-application.module';
import { ApplicationSlatComponent } from './application-slat/application-slat.component';
import { FormAlertsComponent } from './form-alerts/form-alerts.component';
import { MyApplicationsPageComponent } from './my-applications-page/my-applications-page.component';
import { RevisionAlertsComponent } from './revision-alerts/revision-alerts.component';
import { ApplicantCommunicationsModule } from '@features/applicant-communications/applicant-communications.module';

@NgModule({
  imports: [
    CommonModule,
    GCCoreModule,
    CancelApplicationModule,
    ApplicantCommunicationsModule
  ],
  declarations: [
    MyApplicationsPageComponent,
    ApplicationSlatComponent,
    RevisionAlertsComponent,
    FormAlertsComponent
  ],
  exports: [
    ApplicationSlatComponent,
    FormAlertsComponent
  ]
})
export class MyApplicationsModule { }
